(() => {
  'use strict';
  const configNode = document.getElementById('formed-waitlist-config');
  if (!configNode || configNode.dataset.initialized) return;
  configNode.dataset.initialized = 'true';
  const config = JSON.parse(configNode.textContent);
  let active = null;
  let openTimer;

  function contextFor(button) {
    const data = button.dataset;
    const form = button.form || button.closest('form');
    const input = form?.querySelector('select[name="id"], input[name="id"]:checked, input[name="id"][type="hidden"]');
    const variants = JSON.parse(data.variants || '[]');
    const selected = input?.value || (data.waitlistSource === 'product_page' ? new URL(location.href).searchParams.get('variant') : null);
    const variant = variants.find(item => item.id === String(selected));
    return {
      ProductID: data.productId,
      ProductName: data.productTitle,
      ProductHandle: data.productHandle,
      ProductURL: new URL(data.productUrl, location.origin).href,
      VariantID: variant?.id || '',
      VariantName: variant?.title || '',
      SignupLocation: data.waitlistSource,
      PagePath: location.pathname,
      FormID: config.formId
    };
  }

  function open(button) {
    clearTimeout(openTimer);
    button.parentElement.querySelector('[data-formed-waitlist-error]')?.remove();
    active = { context: contextFor(button), emails: new Set() };
    openTimer = setTimeout(() => {
      active = null;
      const error = document.createElement('p');
      error.className = 'formed-waitlist-error';
      error.dataset.formedWaitlistError = '';
      error.setAttribute('role', 'status');
      error.textContent = config.error;
      button.after(error);
    }, 10000);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', config.formId]);
  }

  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[data-formed-waitlist]') : null;
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(button);
  }, true);

  document.addEventListener('submit', event => {
    const button = event.target.querySelector?.('[data-formed-waitlist]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(button);
  }, true);

  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail;
    if (detail?.formId !== config.formId) return;
    if (detail.type === 'open') {
      clearTimeout(openTimer);
      return;
    }
    if (detail.type === 'close') {
      clearTimeout(openTimer);
      active = null;
      return;
    }
    if (!active || !['submit', 'stepSubmit'].includes(detail.type)) return;
    const email = detail.metaData?.email;
    if (typeof email !== 'string' || !email.trim() || active.emails.has(email)) return;
    const sdk = window.klaviyo;
    if (!sdk?.identify || !sdk?.track) return;
    active.emails.add(email);
    const context = { ...active.context };
    const properties = {
      email,
      'Prelaunch Insider': 'Yes',
      ['Waitlist: ' + context.ProductName]: 'Yes'
    };
    if (context.VariantID) properties['Waitlist: ' + context.ProductName + ' / ' + context.VariantName] = 'Yes';
    sdk.identify(properties, () => sdk.track('Joined Product Waitlist', context));
  });
})();
